import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { triggerHaptic } from '../../utils/haptics';

const Header = ({ title, _t, onBack }) => (
  <div className="flex items-center gap-3 mb-8 text-[var(--neon-primary)] cursor-pointer hover:opacity-80 transition-opacity" onClick={() => { triggerHaptic(); onBack(); }}>
    <div className="p-2 glass-card rounded-xl"><ChevronLeft size={18} /></div>
    <span className="text-white font-bold text-xl tracking-wide glow-text-white">{title}</span>
  </div>
);

export default Header;
